export const parseCSSSizeString = (size: string) => {
  const amount: number = parseFloat(size);
  const unit: string = size.replace(amount.toString(), '');
  return { amount, unit };
};
